import { type PartnerResponse } from '@sr/types';
import { getIsPartnerActive, getPartnerDisplayFields } from '@sr/utils';
import { type PartnerInfo } from '../types';

export { getIsPartnerActive };

const sortByName = (partners: PartnerInfo[], sortDirection: 'ASC' | 'DESC') => {
  return partners.sort((a: PartnerInfo, b: PartnerInfo) => {
    if (sortDirection === 'ASC') {
      return a.name.localeCompare(b.name, 'sv');
    }

    return b.name.localeCompare(a.name, 'sv');
  });
};

export const transformSinglePartnerResponse = (res: PartnerResponse): PartnerInfo => {
  const { name, description, street, isPartHierarchy } = getPartnerDisplayFields(res);

  return {
    id: res.id,
    companyId: res.companyId,
    dwKey: res.dwKey,
    name,
    description,
    childCount: res.childCount,
    isActivePickupPlace: getIsPartnerActive(res),
    isPartHierarchy,
    source: res.source,
    address: {
      street,
      city: res.city,
      zipcode: res.postalCode,
    },
    billable: res.billable,
    isPriceAgreed: res.isPriceAgreed,
    locationCount: res.locationCount,
    isActive: res.isActive,
  };
};

export const transformPartnerResponse = (resp: PartnerResponse[], sort?: boolean) => {
  const partners = resp.map(transformSinglePartnerResponse);

  if (sort) {
    return sortByName(partners, 'ASC');
  }

  return partners;
};
